import React from "react";
import { View, StyleSheet, ScrollView } from "react-native";
import CustomText from "../../common/general/CustomText/CustomText";
import useResponsiveScreen from "../../../hooks/useResponsiveScreen";
import ProgressTracker from "../ProgressTracker/ProgressTracker";

const ProgressLightMenu = ({ objectivesData }) => {
  const { isMedium } = useResponsiveScreen();

  return (
    <View role="menu" style={[styles.containerBase, isMedium ? styles.containerDesktop : styles.containerMobile]}>
      <ScrollView
        showsVerticalScrollIndicator={true}
        style={styles.mainScrollView}
        contentContainerStyle={styles.scrollContentContainer}>
        {objectivesData?.length === 0 ? (
          <View style={styles.view}>
            <CustomText
              useTranslationText={false}
              styleType="dark"
              text="Initializing Experience..."
              size="."
              textType="text"
              weight="bold"
            />
          </View>
        ) : (
          <View style={styles.trackerContainer}>
            <ProgressTracker data={objectivesData} />
          </View>
        )}
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  mainScrollView: {
    flexGrow: 1,
    width: "100%",
  },
  scrollContentContainer: {
    flexGrow: 1,
    paddingBottom: 100,
  },
  trackerContainer: {
    width: "100%",
  },
  containerBase: {
    flex: 1,
    alignSelf: "flex-start",
    overflow: "hidden",
    width: 270,
    maxHeight: "calc(100vh - 120px)",
    paddingTop: 32,
    paddingHorizontal: 8,
  },
  containerDesktop: {
    borderRadius: 20,
  },
  containerMobile: {
    top: 0,
    left: 0,
    borderRadius: 0,
    height: "100%",
  },
  view: {
    paddingHorizontal: 8,
    justifyContent: "flex-start",
    paddingBottom: 20,
  },
});

export default ProgressLightMenu;
